"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "staranzano": {
    "54dc3422": [{
      "hkey": "6300d426",
      "slug": "staranzano",
      "name": "Staranzano",
      "primary": true,
      "skipSearch": false
    }],
    "alberoni": [{
      "hkey": "6300d426",
      "slug": "staranzano",
      "name": "Staranzano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "639d5e9d": [{
      "hkey": "6300d426",
      "slug": "staranzano",
      "name": "Staranzano",
      "primary": true,
      "skipSearch": false
    }],
    "bistrigna": [{
      "hkey": "6300d426",
      "slug": "staranzano",
      "name": "Staranzano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e1b908fd": [{
      "hkey": "6300d426",
      "slug": "staranzano",
      "name": "Staranzano",
      "primary": true,
      "skipSearch": false
    }],
    "dobbia": [{
      "hkey": "6300d426",
      "slug": "staranzano",
      "name": "Staranzano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "088cf918": [{
      "hkey": "6300d426",
      "slug": "staranzano",
      "name": "Staranzano",
      "primary": true,
      "skipSearch": false
    }],
    "lido-di-staranzano": [{
      "hkey": "6300d426",
      "slug": "staranzano",
      "name": "Staranzano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "73b75f75": [{
      "hkey": "6300d426",
      "slug": "staranzano",
      "name": "Staranzano",
      "primary": true,
      "skipSearch": false
    }],
    "quarantia": [{
      "hkey": "6300d426",
      "slug": "staranzano",
      "name": "Staranzano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;